/* eslint-disable no-use-before-define */
/* eslint-disable no-console */
import React, { useState, useEffect } from "react";
import { Row, Col, Menu, Dropdown, Button, message, Skeleton } from "antd";
import { DownOutlined } from "@ant-design/icons";
import { Map, TileLayer, GeoJSON } from "react-leaflet";
import L from "leaflet";
import Layout from "../../../layouts/MocoLayout";
import { MocoCard, ChartCard } from "../../../components/widget";
import { NavigationMenuCard } from "../../../components/ui";
import oRest from "../../../apis/rest";
import config from "./index.config";
import mData from "./data";
import "./index.scss";

const MAP_URL = `https://api.mapbox.com/styles/v1/mapbox/light-v10/tiles/{z}/{x}/{y}?access_token=${process.env.REACT_APP_MAP_API_KEY}`;
const ATTRIBUTION =
  '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors';
const API_URL = "webhook/dataquery/?qname=";

const Page = () => {
  const [cards, setCards] = useState(config.cards);
  const [mapData, setMapData] = useState(null);
  const [mapKey, setMapKey] = useState(0);
  const [nasionalValue, setNasionalValue] = useState({ indeks: 0 });
  const [dimensionMenu, setDimensionMenu] = useState("indeks_karakter");
  const [year, setYear] = useState("2020");
  const [chartData, setChartData] = useState(null);

  // Fetch API for All
  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data } = await oRest.get(
          `${API_URL}kemenag_all_index_by_year&year=${year}`
        );

        setChartData(data.filter((e) => e.provinsi !== "NASIONAL"));

        const mapFeatures = mData.features.map((e) => {
          const temp = data.filter((element) => {
            return element.provinsi === e.properties.provinsi;
          });

          return {
            ...e,
            properties: {
              ...e.properties,
              indeks: temp[0].indeks_karakter,
              ...temp[0],
            },
          };
        });

        const nasional = data.filter((e) => e.provinsi === "NASIONAL")[0];

        setNasionalValue({
          indeks: nasional.indeks_karakter,
          indeks_karakter: nasional.indeks_karakter,
          gotong_royong: nasional.gotong_royong,
          integritas: nasional.integritas,
          kemandirian: nasional.kemandirian,
          nasionalisme: nasional.nasionalisme,
          relijiusitas: nasional.relijiusitas,
        });

        setMapData({
          type: "FeatureCollection",
          features: mapFeatures,
        });

        const temp = data
          .filter((e) => e.provinsi !== "NASIONAL")
          .sort((a, b) => (a.indeks_karakter >= b.indeks_karakter ? -1 : 1))
          .map((e) => [e.provinsi, e.indeks_karakter]);

        // Set Data for Charts
        setCards((card) => ({
          ...card,
          chart: {
            ...card.chart,
            indeksKarakter: {
              ...card.chart.indeksKarakter,
              content: {
                ...card.chart.indeksKarakter.content,
                title: `Grafik ${formatTitle(
                  dimensionMenu
                )} Siswa Tahun ${year}`,
              },
              options: {
                ...card.chart.indeksKarakter.options,
                chartOption: {
                  ...card.chart.indeksKarakter.options.chartOption,
                  dataset: [
                    {
                      ...card.chart.indeksKarakter.options.chartOption
                        .dataset[0],
                      source: temp,
                    },
                    card.chart.indeksKarakter.options.chartOption.dataset[1],
                  ],
                  series: {
                    ...card.chart.indeksKarakter.options.chartOption.series,
                    markLine: {
                      data: [
                        {
                          name: "Nasional",
                          yAxis: nasional.indeks_karakter,
                        },
                      ],
                    },
                  },
                },
                dataSource: temp.map((e, idx) => ({
                  id: idx,
                  provinsi: e[0],
                  indeks: e[1],
                })),
              },
              state: {
                data,
              },
            },
          },
        }));
      } catch (error) {
        console.log(error);
        message.error("Terjadi kesalahan");
      }
    };
    fetchData();
  }, [year]);

  // Handle Change Dimension Menu
  useEffect(() => {
    const handleChangeDimensionMenu = () => {
      setMapData((prev) => ({
        ...prev,
        features: prev.features.map((e) => ({
          ...e,
          properties: { ...e.properties, indeks: e.properties[dimensionMenu] },
        })),
      }));

      setNasionalValue((prev) => ({
        ...prev,
        indeks: prev[dimensionMenu],
      }));

      const temp = chartData
        .filter((e) => e.provinsi !== "NASIONAL")
        .sort((a, b) => (a[dimensionMenu] >= b[dimensionMenu] ? -1 : 1))
        .map((e) => [e.provinsi, e[dimensionMenu]]);

      setCards((card) => ({
        ...card,
        map: {
          ...card.map,
          content: {
            ...card.map.content,
            subtitle: `${formatTitle(dimensionMenu)} Siswa`,
          },
        },
        chart: {
          ...card.chart,
          indeksKarakter: {
            ...card.chart.indeksKarakter,
            content: {
              ...card.chart.indeksKarakter.content,
              title: `Grafik ${formatTitle(dimensionMenu)} Siswa Tahun ${year}`,
            },
            options: {
              ...card.chart.indeksKarakter.options,
              chartOption: {
                ...card.chart.indeksKarakter.options.chartOption,
                dataset: [
                  {
                    ...card.chart.indeksKarakter.options.chartOption.dataset[0],
                    source: temp,
                  },
                  card.chart.indeksKarakter.options.chartOption.dataset[1],
                ],
                series: {
                  ...card.chart.indeksKarakter.options.chartOption.series,
                  markLine: {
                    data: [
                      {
                        name: "Nasional",
                        yAxis: nasionalValue[dimensionMenu],
                      },
                    ],
                  },
                },
              },
              dataSource: temp.map((e, idx) => ({
                id: idx,
                provinsi: e[0],
                indeks: e[1],
              })),
            },
          },
        },
      }));
    };

    if (mapData !== null) handleChangeDimensionMenu();
  }, [dimensionMenu, year]);

  useEffect(() => {
    setMapKey(Math.floor(Math.random() * 10) + 1);
  }, [mapData]);

  const handleChangeYearMenu = (e) => {
    setYear(e.key);
  };

  const yearMenu = (
    <Menu>
      <Menu.Item onClick={handleChangeYearMenu} key="2019">
        2019
      </Menu.Item>
      <Menu.Item onClick={handleChangeYearMenu} key="2020">
        2020
      </Menu.Item>
      <Menu.Item onClick={handleChangeYearMenu} key="2021">
        2021
      </Menu.Item>
      <Menu.Item onClick={handleChangeYearMenu} key="2022">
        2022
      </Menu.Item>
    </Menu>
  );
  const handleChangeIndeksMenu = (e) => {
    setDimensionMenu(e.key);
  };

  const dimensionDropdownMenu = (
    <Menu>
      <Menu.Item onClick={handleChangeIndeksMenu} key="indeks_karakter">
        Indeks Karakter
      </Menu.Item>
      <Menu.Item onClick={handleChangeIndeksMenu} key="integritas">
        Integritas
      </Menu.Item>
      <Menu.Item onClick={handleChangeIndeksMenu} key="nasionalisme">
        Nasionalisme
      </Menu.Item>
      <Menu.Item onClick={handleChangeIndeksMenu} key="kemandirian">
        Kemandirian
      </Menu.Item>
      <Menu.Item onClick={handleChangeIndeksMenu} key="relijiusitas">
        Relijiusitas
      </Menu.Item>
      <Menu.Item onClick={handleChangeIndeksMenu} key="gotong_royong">
        Gotong Royong
      </Menu.Item>
    </Menu>
  );

  const getColor = (indeks, threshold) => {
    if (indeks < threshold) return "#F0CD5A";
    return "#90D16D";
  };

  const mapStyle = (feature) => {
    return {
      fillColor: getColor(feature.properties.indeks, nasionalValue.indeks),
      color: "white",
      weight: 1,
      opacity: 1,
      fillOpacity: 0.7,
    };
  };

  const formatTitle = (value) => {
    return (
      (value === "indeks_karakter" ? "" : "Dimensi ") +
      value
        .split("_")
        .map((e) => e.charAt(0).toUpperCase() + e.slice(1).toLowerCase())
        .join(" ")
    );
  };

  return (
    <Layout>
      <NavigationMenuCard
        menu={[
          { title: "Indeks Karakter", path: "/indeks-karakter-siswa/1" },
          { title: "Peta Sebaran", path: "/indeks-karakter-siswa/2" },
          { title: "Detail Data", path: "/indeks-karakter-siswa/3" },
        ]}
      />
      <Row
        justify="space-between"
        gutter={[24, 24]}
        style={{ marginTop: 24, marginBottom: 24 }}
        id="PetaSebaran"
      >
        <Col span={24}>
          <Row justify="end">
            <Dropdown overlay={yearMenu}>
              <Button
                size="large"
                shape="round"
                style={{
                  backgroundColor: "#1B6FBA",
                  color: "#fff",
                }}
              >
                Pilih tahun &nbsp;
                <DownOutlined />
              </Button>
            </Dropdown>
            <Dropdown overlay={dimensionDropdownMenu}>
              <Button
                size="large"
                shape="round"
                style={{
                  backgroundColor: "#1B6FBA",
                  color: "#fff",
                }}
              >
                Pilih dimensi &nbsp;
                <DownOutlined />
              </Button>
            </Dropdown>
          </Row>
        </Col>
        <Col span={18}>
          <MocoCard {...cards.map.content}>
            <div
              style={{
                minHeight: 600,
              }}
            >
              <Skeleton loading={!mapData}>
                <Map
                  zoom={5}
                  minZoom={4}
                  maxZoom={12}
                  center={[2.0450883, 113.3616476]}
                  maxBounds={L.latLngBounds(
                    [11.83222, 89.004448],
                    [-18.680253, 153.691949]
                  )}
                >
                  <TileLayer attribution={ATTRIBUTION} url={MAP_URL} />
                  <GeoJSON
                    key={mapKey}
                    data={mapData}
                    style={mapStyle}
                    onEachFeature={(feature, layer) => {
                      layer.bindTooltip(
                        // eslint-disable-next-line prettier/prettier
                        `${feature.properties.provinsi} <br/> ${formatTitle(dimensionMenu)}: ${feature.properties[dimensionMenu]}`
                      );
                    }}
                  />
                </Map>
              </Skeleton>
            </div>
          </MocoCard>
        </Col>
        <Col span={6}>
          <MocoCard
            {...config.cards.legend.content}
            style={{
              height: "100%",
            }}
          >
            <div
              style={{
                display: "flex",
                flexFlow: "column",
                justifyContent: "center",
              }}
            >
              <div
                style={{
                  width: 200,
                  height: 200,
                  margin: "auto",
                  borderRadius: "100%",
                  backgroundColor: "#F0CD5A",
                }}
              />
              <div
                className="text-header"
                style={{
                  color: "#3F3F3F",
                  textAlign: "center",
                  marginBottom: 24,
                }}
              >
                Dibawah Nasional
              </div>
              <div
                style={{
                  width: 200,
                  height: 200,
                  margin: "auto",
                  borderRadius: "100%",
                  backgroundColor: "#90D16D",
                }}
              />
              <div
                className="text-header"
                style={{
                  color: "#3F3F3F",
                  textAlign: "center",
                  marginBottom: 24,
                }}
              >
                Diatas Nasional
              </div>
            </div>
          </MocoCard>
        </Col>
        <Col span={24} className="card_chart">
          <ChartCard {...cards.chart.indeksKarakter} />
        </Col>
      </Row>
    </Layout>
  );
};

export default Page;
